<template>
    <div class="card-details">
      <div id="head-form-details">
          <i class="fas fa-edit"></i>
          <p id="text-head-detail">INFORMAÇÕES</p>
      </div>
      <div id="body-form-details">
          <div>
              <p class="title-body">SOLICITAÇÃO</p>
          </div>
           <div class="label-res">
              <p class="sub-title">Situação</p>
              <div class="styleSituacao" :style="colorSituacao ? 'background-color:#008144' : 'background-color:red' ">
                   <p class="result-info situacao" >{{descricaoSituacao}}</p>
              </div>
          </div>
          <div class="label-res">
                      <p class="sub-title">Obra</p>
                      <p class="result-info">{{dataDetails.obra.localizacao}}</p>
                  </div>
          <div class="d-flex">
              <div class="label-res w-100">
                  <p class="sub-title">Dt Solicitação</p>
                  <p class="result-info">{{dataDetails.dataSolicitacaoFimFormat}}</p>
              </div>
              <div class="second">
              </div>
          </div>
           <div class="d-flex">
              <div class="label-res">
                  <p class="sub-title">Responsável</p>
                  <p class="result-info">{{dataDetails.responsavel.nome}}</p>
              </div>
              <div class="second">
                   <div class="label-res">
                      <p class="sub-title">Regional</p>
                      <p class="result-info">{{dataDetails.secaoRH.nome}}</p>
                  </div>
              </div>
          </div>
          <div class="label-res">
              <p class="sub-title">Solicitante</p>
              <p class="result-info">{{dataTermo == null ? dataDetails.solicitante.nome : dataTermo.solicitante}}</p>
          </div>
          <hr>
        <div class="viagem-header">
            <div class="w-50">
              <p class="title-body">VIAGEM</p>
            </div>
            <div class="edicao" v-if="dataTermo.situacao == 1 || dataTermo.situacao == 5 && dataTermo.venda == false && (hasRole(roles.RW_REAL_ESTA_ADMIN) || hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL))">
                <div class="button_Edicao">
                    <p @click="editAdiantamento"><i class="fas fa-pen icone-pen"></i></p>
                </div>
            </div>
        </div>
           <div class="d-flex">
              <div class="label-res">
                  <p class="sub-title">Periodo</p>
                  <p class="result-info">{{dataTermo.dataViagemInicio  }} á  {{dataTermo.dataViagemFim}}</p>
              </div>
              <div class="second">
                  <div class="label-res">
                      <p class="sub-title">Motivo</p>
                      <p class="result-info">{{dataTermo.motivoViagem}}</p>
                  </div>
              </div>
          </div>
           <div class="d-flex">
              <div class="label-res">
                  <p class="sub-title">Cidade Origem</p>
                  <p class="result-info">{{dataTermo.cidadeOrigemNome}}</p>
              </div>
              <div class="second">
                   <div class="label-res">
                      <p class="sub-title">Cidade Destino</p>
                      <p class="result-info">{{dataTermo.cidadeDestinoNome}}</p>
                  </div>
              </div>
          </div>
           <div class="d-flex">
                  <div class="label-res">
                      <p class="sub-title">Funcionário</p>
                      <p class="result-info" :class="isFired">{{dataDetails.favorecido.nome}}</p>
                  </div>
                <div class="second">
                   <div class="label-res">
                      <p class="sub-title">Função Funcionário</p>
                      <p class="result-info">{{dataDetails.favorecido.cargo.nome}}</p>
                  </div>
              </div>
          </div>

          <div class="d-flex">
              <div class="semAdiantamento">
                  <!-- <div><input type="checkbox" id="checkbox-circle1" name="check" :disabled="true" v-model="DespesasemAdiantamento"><span class="checkmark"></span></div> -->
                  <div class="sub-title">COM ADIANTAMENTO?</div>
                  <div class="result-info" :style="DespesasemAdiantamento ? 'color: red' : ''" v-if="DespesasemAdiantamento" >
                      Não
                  </div>
                  <div class="result-info" :style="!DespesasemAdiantamento ? 'color: #008144' : ''" v-else>
                      Sim
                  </div>
              </div>
          </div>

            <p class="sub-title">Observação</p>
            <p class="result-info">{{dataDetails.justificativa}}</p> {{dataTermo.situaca}}
            <div class="d-flex justify-content-center button-footer" v-if="verificarAcess(dataTermo.situacao) && parseInt(dataTermo.situacao) >= 0">
                  <button @click="aprovar" v-if="!comission && dataTermo.situacao < 2 || dataTermo.situacao == 5" class="btn-apr"><i class="fas fa-thumbs-up mr-2"></i>APROVAR</button>
                  <button  v-if="comission && dataTermo.situacao < 2" class="btn-apr">ENVIAR PARA APROVAÇÃO</button>
            </div>
            <div class="d-flex justify-content-center mt-3" v-if="verificarAcess(dataTermo.situacao)">
                  <button @click="reprovar" v-if="!comission && colorSituacao && dataTermo.situacao < 2 || dataTermo.situacao == 5" class="btn-rep"><i class="fas fa-thumbs-down mr-2"></i>REPROVAR</button>
                  <button v-if="comission && dataTermo.situacao < 2"  class="btn-exc">EXCLUIR</button>
            </div>
            <div class="d-flex justify-content-center mt-3" v-if="!comission && ((hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_ADMIN_APPROVAL) && parseInt(dataTermo.situacao) === -4) || (hasRole(roles.ACC_FIN_TRAVELREFUND_SEARCH_CONTROLLER_APPROVAL) && [-4, 0, 5, 1, 2].includes(parseInt(dataTermo.situacao))))">
                  <button @click="excluirTerm" class="btn-exc"><i class="fas fa-trash mr-2"></i>EXCLUIR</button>
            </div>
      </div>

        <b-modal
            hide-footer
            centered
            :title="'EDITAR VIAGEM'"
            size="lg"
            ref="edita-viagem-term"
            id="edita-viagem-term">
              <div>
                  <div class="header-body">
                    <div class="card-solicitacao">
                        <div class="label-num">NÚMERO DA SOLICITAÇÃO</div>
                         <div class="numSolicita">{{dataDetails.solicitacaoNumero}}</div>
                    </div>
                    <div class="d-flex">
                        <div class="col-md-6">
                            <label class="label-search">Pais / Estado / Cidade Origem:</label>
                            <div class="d-flex local_destino">
                                <b-form-select v-model="form.paisOrigemID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryEnd">
                                    <template slot="first" v-if="dataCountry.length >= 2">
                                    <option :value="null" >Selecione</option>
                                    <option  v-for="data in dataCountry" :key="data.id" :value="data.id">{{data.nome}}</option>
                                    </template>

                                    <template slot="first" v-else>
                                    <option  :value="null">{{dataCountry[0].nome}}</option>
                                    </template>
                                </b-form-select>
                                <b-form-select v-model="dataTermo.estadoOrigemId" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeStateOrigem">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataStateFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                                <b-form-select v-model="dataTermo.cidadeOrigemId" class="mb-3" style="max-width: 180px;margin-right: 2px">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCityOrigem" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                            </div>
                        </div>

                        <div class="col-md-6">
                            <label class="label-search">Pais / Estado / Cidade Destino:</label>
                            <div class="d-flex local_destino">
                                <b-form-select v-model="form.paisDestinoID.value" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeCountryFim">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCountry" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                                <b-form-select v-model="dataTermo.estadoDestinoID" class="mb-3" style="max-width: 180px;margin-right: 2px" @change="onChangeStateFim">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataStateFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                                <!-- <b-form-select v-model="dataTermo.cidadeDestinoId" class="mb-3" style="max-width: 180px;margin-right: 2px">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCityFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select> -->

                                <b-form-select v-model="dataTermo.cidadeDestinoId" class="mb-3" style="max-width: 180px;margin-right: 2px">
                                    <template slot="first">
                                    <option :value="null">Selecione</option>
                                    </template>
                                    <option v-for="data in dataCityFim" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </b-form-select>
                            </div>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="col-md-12" v-if="solicitanteEdicao === true">
                            <label class="label-search">Solicitante</label>
                            <div class="d-flex">
                                        <autocomplete-z ref="responsavelTypeaheads"
                                        iconClass="fas fa-users"
                                        placeholder="Digite o código do Responsável"
                                        :showAllResults="true"
                                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                                        debounceLength="1"
                                        :ShowCode="false"
                                        :formField="BuscaCodigo"
                                        v-on:search="onSearchResponsavelCode" />
                                        <autocomplete-z ref="responsavelTypeahead"
                                        placeholder="Digite o nome do Responsável"
                                        :showAllResults="true"
                                        :serializer="(responsavels) => responsavels.codigo + ' - ' + responsavels.nome"
                                        debounceLength="4"
                                        :ShowCode="false"
                                        :disabled="codigoResponsavel"
                                        :formField="BuscaNome"
                                        v-on:search="onSearchResponsavel" />
                            </div>
                        </div>
                        <div class="col-md-11" v-if="solicitanteEdicao === false">
                            <label class="label-search">Solicitante</label>
                            <input v-model="dataTermo.solicitante" class="input-details" disabled>
                        </div>
                        <div class="col-md-1 ajuste-icone" v-if="solicitanteEdicao === false">
                            <button @click="editarSolitante"  class="button-editar"><i class="fas fa-pen" style="color: #ffffff;"></i></button>
                        </div>
                    </div>

                    <div class="d-flex">
                        <div class="col-md-4">
                            <label class="label-search">Inicio Viagem:</label>
                            <datepicker name="txtDateStart"
                                v-model="dataTermo.inicio"
                                :format="'dd/MM/yyyy'"
                                :language="ptBR"
                                :placeholder="$lang.Common.DatePlaceholder"
                                :clear-button="true"
                                :clear-button-icon="'fa fa-close'"
                                :calendar-button="true"
                                :calendar-button-icon="'fa fa-calendar'"
                                :bootstrap-styling="true"
                                :full-month-name="true"
                                :initialView="'day'"
                                :use-utc="true"/>
                        </div>
                        <div class="col-md-4">
                            <label class="label-search">Fim Viagem:</label>
                            <datepicker name="txtDateStart"
                                v-model="dataTermo.fim"
                                :format="'dd/MM/yyyy'"
                                :language="ptBR"
                                :placeholder="$lang.Common.DatePlaceholder"
                                :clear-button="true"
                                :clear-button-icon="'fa fa-close'"
                                :calendar-button="true"
                                :calendar-button-icon="'fa fa-calendar'"
                                :bootstrap-styling="true"
                                :full-month-name="true"
                                :initialView="'day'"
                                :use-utc="true"/>
                        </div>

                        <div class="col-md-4" v-if="dataTermo.motivoViagem != 'Venda'">
                            <label class="label-search">Motivo Viagem:</label>
                            <b-form-select v-model="dataTermo.motivoViagemId">
                                <template slot="first">
                                    <option :value="null">Selecione</option>
                                    <option v-for="data in dataTravel" :key="data.id" :value="data.id">{{data.nome}}</option>
                                </template>
                            </b-form-select>
                        </div>
                    </div>
                      <div  class="button-corpo">
                        <button @click="fecharPopUp"  class="button-cance"> CANCELAR </button>
                        <button @click="EditarTermo" class="button-save" >SALVAR </button>
                      </div>
                  </div>
              </div>
          </b-modal>
    </div>
  </template>

<script>
import PanelTravelAdvance from './PanelTravelAdvance'
export default PanelTravelAdvance
</script>

  <style scoped>
  .button-editar{
    margin-top: 10;
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 36px;
    height: 40px;
  }
  .button-editar{
    background-color: #008148;
    color: white;

  }
.card-solicitacao{
   background-color: #f1f1f1;
    width: 95%;
    display: flex;
    height: fit-content;
    padding: 1rem;
    gap: 1rem;
    border-radius: 12px;
    margin: 0 0 0 1rem;
}
  .ajuste-icone{
    display: flex;
    justify-content: end;
    align-items: flex-end;
  }
  .input-details{
    width: 100%;
    height: 36px;
    background-color: 100%;
    border: 1px solid #D4D9DE;
    border-radius: 5px;
    outline: none;
    padding-left: 1rem;
  }
  .button-cance{
   outline: transparent;
   border: transparent;
   border-radius: 4px;
   text-transform: uppercase;
   width: 190px;
   height: 40px;
   background-color: #aa1414;
   color: white;
 }
   .button-save{
    outline: transparent;
    border: transparent;
    border-radius: 4px;
    text-transform: uppercase;
    width: 190px;
    height: 40px;
    background-color: #008148;
    color: white;
  }
  .button-corpo{
    display: flex;
    justify-content: center;
    gap: 1rem;
    margin-top: 3rem;
  }
  .numSolicita{
    text-align: center;
    font-size: 18px;
    color: #008144;
    font-weight: bold;
  }
  .label-num{
    text-align: center;
  }
  .viagem-header{
    display: flex;
    width: 100%;
  }
  .icone-pen{
    font-size: 15px;
    color: white;
    cursor: pointer;
  }
  .edicao{
        width: 50%;
        display: flex;
        justify-content: end;
  }
  .button_Edicao {
    background-color:  #008148;
    width: 30%;
    height: 2rem;
    padding: 7px;
    display: flex;
    justify-content: center;
    border-radius: 10px;
  }
  .semAdiantamento{
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      margin-top: 2.5rem;
  }
  .result-info{
      font-weight: bold;
      margin: 0px;
      font-size: 14px !important;
      padding: 0px;
  }
  .result-info-red{
      font-weight: bold;
      margin: 0px;
      font-size: 14px !important;
      padding: 0px;
      color: #dc3545;
  }
  .card-details{
      height: 100%;
      background: white;
      border-radius: 10px 10px 0px 0px;
  }
  #body-form-details{
      padding: 25px;
  }
  .styleSituacao {
      width: 180px;
      display: flex;
      justify-content: center;
      align-items: center;
      height: 35px;
      font-size: 10px;
      border-radius: 25px;
  }
  #head-form-details{
      width: 100%;
      height: 40px;
      display: flex;
      padding-left: 15px;
      color:#008144;
      align-items: center;
      background: #ECEFF1;
      border-radius: 10px 10px 0px 0px;
  }
  .situacao{
      font-weight: bold;
      color: white;
      font-size: 10px !important;
  }
  .label-res{
      max-width: 40%;
      min-width: 40%;
  }
  .btn-apr{
      background: #008144;
      width: 80%;
      height: 40px;
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
  }
  .btn-apr:hover{
      background: #01572f;

  }
  .btn-rep:hover{
      background: rgb(160, 0, 0);
  }
  .button-footer{
      margin-top: 50px;
  }
  .btn-exc{
      background: #ECEFF1;
      width: 80%;
      height: 40px;
      color: black;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
  }
  .btn-rep{
      background: red;
      width: 80%;
      height: 40px;
      color: white;
      border: none;
      border-radius: 8px;
      font-size: 16px;
      font-weight: bold;
  }
  #text-head-detail{
      padding-left: 8px;
      padding-top: 19px;
      font-weight: bold;
  }
  .second{
      padding-left: 75px;
  }
  .title-body{
      font-size: 14px;
      font-weight: bold;
      color: #008144;
  }
  .sub-title{
      font-size: 14px;
      margin-top: 20px;
      margin-bottom: 0px;
      font-weight: 500;
  }
  </style>



// WEBPACK FOOTER //
// src/views/private/travelreimbursement/components/PanelTravelAdvance/PanelTravelAdvance.vue